
import { IAppContext } from '../../types';
import { Experiments } from '../../enums';

export const isRedirectToCartFlow = (context: IAppContext) => {
  const { experiments } = context;

  const isDomainUpSellCart =
    experiments[Experiments.DomainUpSell] === 'true';

  const isStorefrontToCartExperiment =
    experiments[Experiments.StorefrontToCart] === 'true';

  const isSplitPageWithCartExperiment =
    experiments[Experiments.SplitPageWithCart] === 'true';

  const searchParams = new URLSearchParams(window.location.search);

  return (
    Boolean(searchParams.get('referrer')) &&
    (isStorefrontToCartExperiment || isSplitPageWithCartExperiment || isDomainUpSellCart)
  );
};
